import React from "react";
import { getCategoryFieldSchema } from "../../../../config/rentalCategoryFormConfig";

const RentalCategoryFieldsSection = ({
    formType,
    formData,
    onChange,
    onCategoryAttributeChange,
    fieldError,
    inputClasses,
    markTouched,
}) => {
    const schema = getCategoryFieldSchema(formType);

    if (!schema) {
        return null;
    }

    const getValue = (field) => {
        if (field.storage === "root") {
            return formData[field.key] ?? "";
        }
        return formData.category_attributes?.[field.key] ?? "";
    };

    const handleFieldChange = (field, value) => {
        if (field.storage === "root") {
            onChange(field.key, value);
            return;
        }
        onCategoryAttributeChange(field.key, value);
    };

    return (
        <div className="rounded-xl border border-gray-100 bg-slate-50/40 p-5 space-y-4">
            {schema.description ? (
                <p className="text-xs text-gray-500">{schema.description}</p>
            ) : null}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {schema.fields.map((field) => {
                    const value = getValue(field);
                    const errorKey =
                        field.storage === "root" ? field.key : `category_attributes.${field.key}`;
                    const hasError = Boolean(fieldError?.(errorKey));
                    const errMsg = fieldError?.(errorKey);
                    const colClass = field.colSpan === 2 ? "md:col-span-2" : "";

                    return (
                        <div key={field.key} className={colClass}>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {field.label}
                                {field.optional ? (
                                    <span className="text-gray-400 font-normal"> (optional)</span>
                                ) : (
                                    <span className="text-red-500"> *</span>
                                )}
                            </label>
                            {field.type === "select" ? (
                                <select
                                    value={value}
                                    onChange={(e) => handleFieldChange(field, e.target.value)}
                                    onBlur={() => markTouched?.(errorKey)}
                                    className={inputClasses(hasError)}
                                >
                                    <option value="">{field.placeholder || "Select"}</option>
                                    {(field.options || []).map((opt) => (
                                        <option key={opt} value={opt}>
                                            {opt}
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    type={field.type === "number" ? "number" : "text"}
                                    value={value}
                                    onChange={(e) => handleFieldChange(field, e.target.value)}
                                    onBlur={() => markTouched?.(errorKey)}
                                    className={inputClasses(hasError)}
                                    placeholder={field.placeholder}
                                />
                            )}
                            {errMsg ? (
                                <div className="text-xs font-medium text-red-600 mt-1.5">{errMsg}</div>
                            ) : null}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RentalCategoryFieldsSection;
